/** Split free-text chief complaints into short symptom tags (local, no AI). */
const SPLIT = /\s*(?:,|;|\n|\||\+|\&| and | with | plus | as well as )\s*/i;
const NOISE = new Set([
  'patient', 'complains', 'complaining', 'of', 'c/o', 'co', 'history',
  'h/o', 'ho', 'presents', 'presenting', 'with', 'the', 'a', 'an', 'and',
]);

export function stripHtml(text = '') {
  return String(text).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function splitSymptoms(text) {
  let clean = stripHtml(text);
  if (!clean) return [];
  clean = clean.replace(/\b[ch]\s*\/\s*o\b/gi, ' ').replace(/\s+/g, ' ').trim();
  const parts = clean.split(SPLIT).map((p) => p.trim().replace(/^[-.\s]+|[-.\s]+$/g, '')).filter(Boolean);
  const out = [];
  const seen = new Set();
  for (const part of parts) {
    const words = part.split(/\s+/).filter((w) => !NOISE.has(w.toLowerCase()));
    let tag = words.join(' ').trim();
    if (tag.length < 2 || tag.length > 40) continue;
    const key = tag.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    tag = tag.charAt(0).toUpperCase() + tag.slice(1);
    out.push(tag);
    if (out.length >= 10) break;
  }
  if (!out.length && clean.length > 1 && clean.length <= 40) {
    return [clean.charAt(0).toUpperCase() + clean.slice(1)];
  }
  return out;
}
